import { ShopifyStore } from 'lib/commerce/shopify/shopifyHelper';

/**
 * Simple pricing map for rare product addons (visual "valued at" prices only)
 * These are just display values, not operational pricing
 */
// TODO: Update AU and CA prices with actual region-specific pricing once available
export const RareAddonPricing: Record<
  ShopifyStore,
  { uhxCoverage: number; lifetimeSoftware: number }
> = {
  [ShopifyStore.IN]: {
    uhxCoverage: 2988,
    lifetimeSoftware: 12899,
  },
  [ShopifyStore.US]: {
    uhxCoverage: 36,
    lifetimeSoftware: 133,
  },
  [ShopifyStore.SA]: {
    uhxCoverage: 155,
    lifetimeSoftware: 575,
  },
  [ShopifyStore.MX]: {
    uhxCoverage: 671,
    lifetimeSoftware: 2449,
  },
  [ShopifyStore.GB]: {
    uhxCoverage: 36,
    lifetimeSoftware: 173,
  },
  [ShopifyStore.EU]: {
    uhxCoverage: 36,
    lifetimeSoftware: 197,
  },
  [ShopifyStore.AE]: {
    uhxCoverage: 144,
    lifetimeSoftware: 500,
  },
  [ShopifyStore.ROW]: {
    uhxCoverage: 36,
    lifetimeSoftware: 157,
  },
  [ShopifyStore.AU]: {
    uhxCoverage: 59,
    lifetimeSoftware: 198,
  },
  [ShopifyStore.CA]: {
    uhxCoverage: 49,
    lifetimeSoftware: 176,
  },
  [ShopifyStore.ZA]: {
    uhxCoverage: 899,
    lifetimeSoftware: 2799,
  },
  [ShopifyStore.JP]: {
    uhxCoverage: 6500,
    lifetimeSoftware: 24000,
  },
};

/**
 * Get the pricing for a specific addon type and store
 */
export const getRareAddonPricing = (
  store: ShopifyStore,
  addonType: 'uhxCoverage' | 'lifetimeSoftware',
): number => {
  return (
    RareAddonPricing[store]?.[addonType] ??
    RareAddonPricing[ShopifyStore.ROW][addonType]
  );
};
